import React, { useState, useEffect } from "react";
import { Loader2 } from "lucide-react";

const POSTS_API = 'https://wiserbeeblogs.vercel.app/api/posts';

const App = () => {
    const [selectedNews, setSelectedNews] = useState(0);
    const [selectedImage, setSelectedImage] = useState('image1');
    const [currentPage, setCurrentPage] = useState(1);
    const [newsData, setNewsData] = useState([]); // Initialize as empty array
    const [isLoading, setIsLoading] = useState(true);
    const itemsPerPage = 2;

    useEffect(() => {
        const fetchNewsData = async () => {
            try {
                setIsLoading(true);
                const apiUrl = window.location.hostname === 'localhost'
                    ? '/api/posts'
                    : POSTS_API;
                const response = await fetch(apiUrl);
                const data = await response.json();

                let posts = [];
                if (Array.isArray(data)) {
                    posts = data;
                } else if (Array.isArray(data?.posts)) {
                    posts = data.posts;
                } else if (Array.isArray(data?.data)) {
                    posts = data.data;
                }

                setNewsData(posts);
            } catch (error) {
                console.error("Error fetching news data:", error);
                setNewsData([]); // Set empty array on error
            } finally {
                setIsLoading(false);
            }
        };

        fetchNewsData();
    }, []);

    const ImageThumbnail = ({ src, index, isSelected, onClick }) => (
        <img
            src={src}
            alt={`thumbnail ${index + 1}`}
            style={{ width: '100px', cursor: 'pointer' }}
            onClick={onClick}
            className={isSelected ? 'border border-primary' : ''}
        />
    );

    const NewsCard = ({ news, index, onClick }) => {
        const truncatedDescription = news.description.split(' ').slice(0, 20).join(' ') + '...';
        return (
            <div key={index} className="card" onClick={onClick} style={{ cursor: 'pointer' }}>
                <div className="card__header">
                    <img src={news.images[0]} alt="card__image" className="card__image" width="600" height='300'/>
                </div>
                <div className="card__body">
                    <span className="tag">News</span>
                    <h4>{news.title}</h4>
                    <p>{truncatedDescription}</p>
                </div>
            </div>
        );
    };

    // Get current news items
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = Array.isArray(newsData)
        ? newsData.slice(indexOfFirstItem, indexOfLastItem)
        : [];

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Loading state
    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Loader2 className="animate-spin" size={48} />
            </div>
        );
    }

    // No data state
    if (!newsData?.length) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <h2>No news available</h2>
            </div>
        );
    }

    return (
        <div>
            <h1 className="text-center my-5 fontSize48">News about the wiserbee</h1>
            <div className="row m-3">
                <div className="col-md-8">
                    <div style={{ width: '100%', height: '500px', borderRadius: '10px', border: '3px solid #251963' }}>
                        <img
                            src={newsData[selectedNews]?.images[parseInt(selectedImage.replace('image', '')) - 1]}
                            alt="news"
                            className="img-fluid mb-3 w-100 h-100"
                            style={{ borderRadius: '8px' }}
                        />
                    </div>
                    <div className="d-flex gap-2 mb-3 mt-3" style={{ height: '80px' }}>
                        {newsData[selectedNews]?.images.map((image, index) => (
                            <ImageThumbnail
                                key={index}
                                src={image}
                                index={index}
                                isSelected={selectedImage === `image${index + 1}`}
                                onClick={() => setSelectedImage(`image${index + 1}`)}
                            />
                        ))}
                    </div>
                    <h1 className="mt-3">{newsData[selectedNews]?.title}</h1>
                    <h1 className="mt-3">Date: {new Date(newsData[selectedNews]?.date).toLocaleDateString()}</h1>
                    <p>{newsData[selectedNews]?.description}</p>
                </div>

                <div className="col-md-4">
                    <div className="news" id="news">
                        <div className="titletext">
                            <h1>News <span>Feed</span></h1>
                        </div>
                        <div className="container">
                            {currentItems.map((news, index) => (
                                <NewsCard
                                    key={index}
                                    news={news}
                                    index={indexOfFirstItem + index}
                                    onClick={() => setSelectedNews(indexOfFirstItem + index)}
                                />
                            ))}
                        </div>
                    </div>
                    <div className="d-flex justify-content-center flex-column align-items-center mt-3">
                        <div className="d-flex">
                            <button
                                onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)}
                                className="btn btn-outline-primary mx-1"
                                disabled={currentPage === 1}
                            >
                                &lt;
                            </button>
                            {[...Array(Math.ceil(newsData.length / itemsPerPage))].map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => paginate(index + 1)}
                                    className={`btn ${currentPage === index + 1 ? 'btn-primary' : 'btn-outline-primary'} mx-1`}
                                >
                                    {index + 1}
                                </button>
                            ))}
                            <button
                                onClick={() => paginate(currentPage < Math.ceil(newsData.length / itemsPerPage) ? currentPage + 1 : currentPage)}
                                className="btn btn-outline-primary mx-1"
                                disabled={currentPage === Math.ceil(newsData.length / itemsPerPage)}
                            >
                                &gt;
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default App;
